<template>
  <div class="block">
    <el-select v-model="selected"
               ref="communeSel"
               placeholder="Ej: Puente Alto"
               value="value"
               @change="selectLocality"
               @clear="clean"
               :disabled="disabled"
               clearable
               filterable>
      <el-option v-for="locality in data.localitiesPerRegion"
                 :key="locality.id"
                 :label="locality.name"
                 :value="locality.name"></el-option>
    </el-select>
  </div>
</template>

<script>
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'BaseSelectLocality',
  data() {
    return {
      data: {
        localities: [],
        localitiesPerRegion: [],
      },
      selected: null,
      disabled: true,
      loading: false,
    };
  },
  props: {
    regionId: Number,
  },
  methods: {
    getAllLocalities() {
      this.loading = true;
      apiRequest({
        module: 'crud',
        service: 'get_localities',
        params: {
          limit: 2500,
        },
      }).then((response) => {
        this.data.localities = response.data;
        sessionStorage.localities = JSON.stringify(
          response.data.sort((a, b) => (b.name > a.name ? -1 : 1)),
        );
        this.loading = false;
      }).catch(() => {
        this.error = 'Get Localities Failed!';
        this.$message.error('Error al obtener las localidades, por favor intente nuevamente');
        this.loading = false;
      });
    },
    selectLocality() {
      for (let i = 0; i < this.data.localities.length; i += 1) {
        if (this.selected === this.data.localities[i].name) {
          this.$emit('sendLocality', this.data.localities[i].id);
        }
      }
    },
    clear() {
      this.data.localities = [];
    },
    clean() {
      // this.data.localities = [];
      this.$emit('sendLocality', []);
    },
    getLocalitiesFromLS() {
      this.data.localities = JSON.parse(sessionStorage.localities);
    },
    filterPerRegion() {
      const newLoccalities = [];
      for (let i = 0; i < this.data.localities.length; i += 1) {
        if (this.data.localities[i].commune.regions_id === this.regionId) {
          newLoccalities.push(this.data.localities[i]);
        }
      }
      this.data.localitiesPerRegion = newLoccalities;
    },
  },
  watch: {
    regionId: function filteredLocalities() {
      if (this.regionId === -1 || this.regionId === 0) {
        this.disabled = true;
        this.selected = null;
      } else {
        this.filterPerRegion();
        this.disabled = false;
      }
    },
  },
  created() {
    if (sessionStorage.localities) {
      this.getLocalitiesFromLS();
    } else {
      this.getAllLocalities();
    }
  },
};
</script>

<style scoped>

</style>
